import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/online-courses/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/online-courses/",
)({
  component: Page,
});
